// Utility functions for URL handling

/**
 * Converts Google Drive share URLs to direct viewable URLs
 * Supports formats:
 * - https://drive.google.com/file/d/FILE_ID/view
 * - https://drive.google.com/open?id=FILE_ID
 * - https://drive.google.com/uc?id=FILE_ID
 */
export const convertGoogleDriveUrl = (url) => {
  if (!url) return url;
  
  // Check if it's a Google Drive URL
  if (url.includes('drive.google.com')) {
    let fileId = null;
    
    // Format: /file/d/FILE_ID/
    const fileMatch = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
    if (fileMatch) {
      fileId = fileMatch[1];
    }
    
    // Format: ?id=FILE_ID or &id=FILE_ID
    if (!fileId) {
      const idMatch = url.match(/[?&]id=([a-zA-Z0-9_-]+)/);
      if (idMatch) {
        fileId = idMatch[1];
      }
    }
    
    // Format: /uc?export=view&id=FILE_ID (already correct format, extract ID)
    if (!fileId) {
      const ucMatch = url.match(/\/uc\?.*id=([a-zA-Z0-9_-]+)/);
      if (ucMatch) {
        fileId = ucMatch[1];
      }
    }
    
    if (fileId) {
      // Return the direct view URL
      return `https://drive.google.com/uc?export=view&id=${fileId}`;
    }
  }
  
  // Return original URL if not a Google Drive URL or couldn't parse
  return url;
};

/**
 * Checks if a URL is a video
 */
export const isVideoUrl = (url) => {
  if (!url) return false;
  const videoExtensions = ['.mp4', '.webm', '.mov', '.avi', '.mkv'];
  const lowerUrl = url.toLowerCase();
  return videoExtensions.some(ext => lowerUrl.includes(ext));
};

/**
 * Gets the media type from URL
 */
export const getMediaType = (url) => {
  return isVideoUrl(url) ? 'video' : 'image';
};
